import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToTarget } from "@/lib/scroll";
import { useLang } from "@/lib/i18n";

export const DfeLogo = ({ size = 40 }) => (
  <img
    src="/api/files/dfe-website/uploads/dfe-logo.png"
    alt="DFE 娛樂夢工廠 Dream Factory Entertainment"
    style={{ height: Math.round(size * 0.72), width: "auto", display: "block" }}
  />
);

const LINKS = [
  { zh: "关于", en: "ABOUT", href: "#about" },
  { zh: "作品", en: "WORKS", href: "#works" },
  { zh: "服务", en: "SERVICES", href: "#services" },
  { zh: "团队", en: "TEAM", href: "#team" },
  { zh: "联络", en: "CONTACT", href: "#contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { lang, setLang } = useLang();
  const toggleLang = () => setLang(lang === "zh" ? "en" : "zh");
  const go = (href) => {
    setOpen(false);
    setTimeout(() => scrollToTarget(href), open ? 250 : 0);
  };
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-[100] bg-[#050505]/95 border-b border-white/10 backdrop-blur-sm">
        <div className="max-w-[1800px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center gap-3 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              scrollToTarget(0);
            }}
          >
            <DfeLogo size={36} />
            <span className="leading-none">
              <span className="block font-display text-lg tracking-wider text-[#f5f5f5]">DFE</span>
              <span className="block font-zh text-[10px] text-[#a1a1aa] tracking-[0.35em]">娛樂夢工廠</span>
            </span>
          </a>
          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`nav-link-${l.en.toLowerCase()}`}
                onClick={() => go(l.href)}
                className="group flex flex-col items-start leading-none cursor-pointer bg-transparent border-0 p-0"
              >
                <span className="font-zh text-sm text-[#f5f5f5] group-hover:text-[#ffde00] transition-colors">
                  {lang === "zh" ? l.zh : l.en}
                </span>
                <span className="font-mono2 text-[9px] text-[#52525b] tracking-[0.3em] mt-0.5 group-hover:text-[#ffde00] transition-colors">
                  {lang === "zh" ? l.en : l.zh}
                </span>
              </button>
            ))}
            <button
              onClick={toggleLang}
              data-testid="lang-toggle"
              className="font-mono2 text-[11px] border border-white/20 px-3 py-1.5 text-[#f5f5f5] hover:border-[#ffde00] hover:text-[#ffde00] transition-colors bg-transparent cursor-pointer tracking-[0.15em]"
            >
              {lang === "zh" ? "EN" : "中文"}
            </button>
            <button data-testid="nav-cta" onClick={() => go("#contact")} className="btn-yellow !py-2.5 !px-5">
              {lang === "zh" ? "商业合作" : "ENQUIRE"}
              <ArrowUpRight size={14} />
            </button>
          </nav>
          <button
            className="md:hidden text-[#f5f5f5] bg-transparent border-0 cursor-pointer p-1"
            data-testid="nav-mobile-toggle"
            aria-label="菜单"
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>
      {open && (
        <div className="fixed inset-0 z-[90] bg-[#050505] pt-24 px-6 md:hidden">
          <nav className="flex flex-col gap-2">
            <button
              onClick={toggleLang}
              className="self-end font-mono2 text-[11px] border border-white/20 px-3 py-1.5 text-[#f5f5f5] bg-transparent cursor-pointer tracking-[0.15em] mb-2"
              data-testid="lang-toggle-mobile"
            >
              {lang === "zh" ? "EN" : "中文"}
            </button>
            {LINKS.map((l, i) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                data-testid={`nav-mobile-link-${l.en.toLowerCase()}`}
                className="text-left bg-transparent border-0 border-b border-white/10 py-4 cursor-pointer flex items-baseline gap-4"
              >
                <span className="font-mono2 text-xs text-[#ffde00]">0{i + 1}</span>
                <span className="font-display text-3xl text-[#f5f5f5] uppercase">{lang === "zh" ? l.zh : l.en}</span>
                <span className="font-mono2 text-[10px] text-[#a1a1aa] tracking-[0.3em]">{lang === "zh" ? l.en : l.zh}</span>
              </button>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
